import { z } from 'zod';

// TODO: Add proper block schema
export const BlockSchema = z
  .object({ id: z.string(), type: z.string() })
  .passthrough();
